import { TDataFS } from "../../pages/payments/types";

export const getValuesDataFS = (dataFS: TDataFS<any>) => {
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(dataFS).map(([k, v]) => [k, (v as any).value])
    )
  );
};
